import { Button } from '@citibox-panel/ui';
import { useSearchTabs } from '../../search-shell/hooks/useSearchTabs';

export interface BoxDeliveriesShortcutProps {
  boxNumber: string;
  // Non-nullable, unlike the banner's own props: the caller has already decided the shortcut is
  // offerable, which is exactly the check that proves these two exist. Taking them nullable here
  // would re-open a question that has been answered one level up.
  locationId: number;
  locationAddress: string;
}

// «Ver entregas»: the one control the «Aviso de estado del buzón» carries. It reads nothing and
// writes nothing — it opens the «Entregas» of the delivery's ubicación, filtered to this «buzón», via
// the shell's own seam. Owning the `useSearchTabs` call here rather than in the banner means the URL
// subscription only exists while the control is actually on screen, instead of on every detail whose
// «buzón» has nothing to report.
//
// This is the slice's only dependency on `search-shell`, and it is acyclic: `search-shell` imports no
// slice, it receives `renderDelivery` from the host.
export function BoxDeliveriesShortcut({
  boxNumber,
  locationId,
  locationAddress,
}: BoxDeliveriesShortcutProps) {
  const { openLocation } = useSearchTabs();

  return (
    <Button
      // `inline`, not `text sentenceCase`: the design puts this label in BOLD and flush with the
      // message above it, and a text button carries MUI's own horizontal padding, which indents it.
      variant="inline"
      size="small"
      // «Ver entregas» alone does not say entregas of WHAT, and with no underline the control does
      // not announce itself as a link outside the sentence it sits under. The label CONTAINS the
      // visible text, as the façade requires — it never replaces it.
      aria-label={`Ver entregas del buzón ${boxNumber}`}
      onClick={() => {
        // 90 days as a FIXED window, not derived from this delivery's own date: the ranges are
        // relative to today, and a «Usuario» only complains about a parcel well after the fact, so
        // anything narrower can exclude the very deliveries this control exists to show. No carrier
        // and no states — as wide as it goes inside this buzón; narrowing is the agent's job, with
        // the «Editar» the location view already has.
        openLocation(locationId, locationAddress, { days: 90, box: boxNumber });
      }}
    >
      {/* TODO: i18n */}
      Ver entregas
    </Button>
  );
}
